<ng-container *ngIf="combineExpandedActiveSection$ | async" />
@if (!this.navigationItem().isOutSideUrl && this.navigationItem().routeUrl) {
  <a
    class="icon-btn no-underline"
    zHoveredLeftMenu
    [menuOptions]="menuOptions"
    [ngClass]="{ 'icon-active': isActive() }"
    [hoverMenuTemplate]="canHover() ? menuContent : undefined"
    (click)="onClick()"
    [forceHide]="!canHover()"
    [routerLink]="this.navigationItem().routeUrl"
  >
    <em [class]="navigationItem().iconClass"></em>
  </a>
} @else {
  <a
    class="icon-btn no-underline"
    zHoveredLeftMenu
    [menuOptions]="menuOptions"
    [ngClass]="{ 'icon-active': isActive() }"
    [hoverMenuTemplate]="canHover() ? menuContent : undefined"
    [forceHide]="!canHover()"
    (click)="navigateToMicroService(this.navigationItem())"
  >
    <em [class]="navigationItem().iconClass"></em>
  </a>
}
<ng-template #menuContent>
  <div class="w-full overflow-menu">
    <div
      class="menu-header flex align-items-center gap-10px text-base line-height-3 font-bold py-12px px-3 h-3rem"
    >
      <div class="body-large-bold">{{ navigationItem().name }}</div>
    </div>
    @for (item of navigationItem().children; track $index) {
      <z-menu-collapse-item
        [menuItemData]="item"
        [active]="activeChild?.id === item?.id"
      />
    }
  </div>
</ng-template>
